import { useParams, useLocation } from 'react-router-dom'

const useQuery = () => {
	const query = new URLSearchParams(useLocation().search)

	const getQueryParam = (param) => {
		if (!param) return null
		return query.get(param)
	}

	const pushQueryParamToHistory = ({ key, value }) => {
		if (window && window.location && window.history) {
			const url = new URL(window.location);
			url.searchParams.set(key, value);
			window.history.pushState({}, "", url);
		}
	}

	const replaceQueryParamInHistory = ({ key, value }) => {
		if (window && window.location && window.history) {
			const url = new URL(window.location);
			url.searchParams.set(key, value);
			window.history.replaceState({}, "", url);
		}
	};

	const params = useParams()

	return { query, params, getQueryParam, pushQueryParamToHistory, replaceQueryParamInHistory }
}

export default useQuery
